// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.c8ef8f {
  position: fixed;
  padding: 0 16px 16px 16px;
  top: 100%;
  left: 50%;
  transform: translate(-50%, 0%);
  background-color: var(--base-background-card);
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  z-index: 1110;
  transition: top 300ms ease-out, transform 300ms ease-out;
}
.fd2066 {
  transform: translate(-50%, -50%);
  top: 50%;
}
.f10030 {
  display: flex;
  align-items: start;
  justify-content: space-between;
  padding: 24px 0;
}
.bad24f {
  align-self: center;
}
.ca411a {
  overflow: auto;
  flex-grow: 1;
}
.ec6e1b {
  padding: 16px 0 0 0;
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.ee87dd {
  margin-top: -12px;
  margin-inline-end: -12px;
}
.cfa66f {
  display: none;
}

@media screen and (min-width: 420px) {
  .f10030 {
    padding: 0 0 32px 0;
  }
  .ec6e1b {
    flex-direction: row-reverse;
  }
  .c59000 {
    padding: 32px;
      height: auto;
      max-height: calc(100% - 64px);
      width: 420px;
  }
  .cfa66f {
    display: block;
  }
}

@media screen and (min-width: 768px) {
  .c08cb8 {
    padding: 32px;
      height: auto;
      max-height: calc(100% - 64px);
      width: 768px;
  }
}`, "",{"version":3,"sources":["webpack://./node_modules/@hm-group/fabric-components/dist/esm/brand/hm/components/Panels/Modal/Modal.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,yBAAyB;EACzB,SAAS;EACT,SAAS;EACT,8BAA8B;EAC9B,6CAA6C;EAC7C,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,wDAAwD;AAC1D;AACA;EACE,gCAAgC;EAChC,QAAQ;AACV;AACA;EACE,aAAa;EACb,kBAAkB;EAClB,8BAA8B;EAC9B,eAAe;AACjB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,YAAY;AACd;AACA;EACE,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,iBAAiB;EAET,wBAAwB;AAClC;AACA;EACE,aAAa;AACf;;AAEA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,aAAa;MACX,YAAY;MACZ,6BAA6B;MAC7B,YAAY;EAChB;EACA;IACE,cAAc;EAChB;AACF;;AAEA;EACE;IACE,aAAa;MACX,YAAY;MACZ,6BAA6B;MAC7B,YAAY;EAChB;AACF","sourcesContent":[".c8ef8f {\n  position: fixed;\n  padding: 0 16px 16px 16px;\n  top: 100%;\n  left: 50%;\n  transform: translate(-50%, 0%);\n  background-color: var(--base-background-card);\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  height: 100%;\n  z-index: 1110;\n  transition: top 300ms ease-out, transform 300ms ease-out;\n}\n.fd2066 {\n  transform: translate(-50%, -50%);\n  top: 50%;\n}\n.f10030 {\n  display: flex;\n  align-items: start;\n  justify-content: space-between;\n  padding: 24px 0;\n}\n.bad24f {\n  align-self: center;\n}\n.ca411a {\n  overflow: auto;\n  flex-grow: 1;\n}\n.ec6e1b {\n  padding: 16px 0 0 0;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n.ee87dd {\n  margin-top: -12px;\n  -webkit-margin-end: -12px;\n          margin-inline-end: -12px;\n}\n.cfa66f {\n  display: none;\n}\n\n@media screen and (min-width: 420px) {\n  .f10030 {\n    padding: 0 0 32px 0;\n  }\n  .ec6e1b {\n    flex-direction: row-reverse;\n  }\n  .c59000 {\n    padding: 32px;\n      height: auto;\n      max-height: calc(100% - 64px);\n      width: 420px;\n  }\n  .cfa66f {\n    display: block;\n  }\n}\n\n@media screen and (min-width: 768px) {\n  .c08cb8 {\n    padding: 32px;\n      height: auto;\n      max-height: calc(100% - 64px);\n      width: 768px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
